import { useMeetingManager } from "amazon-chime-sdk-component-library-react";
import { useEffect, useState } from "react";
import { AttendeeInfo } from "../types/meeting.types";

interface UseAttendeeInfoProps {
  attendeeResponse: AttendeeInfo;
  participantName: string; // This will be providerName for patient or patientName for provider
}

export const useAttendeeInfo = ({
  attendeeResponse,
  participantName
}: UseAttendeeInfoProps) => {
  const [attendeeName, setAttendeeName] = useState<string | undefined>("");
  const meetingManager = useMeetingManager();

  const attendeeId = attendeeResponse?.Attendee?.AttendeeId;
  const externalUserId = attendeeResponse?.Attendee?.ExternalUserId;

  // Set up the getAttendee function
  useEffect(() => {
    meetingManager.getAttendee = async (
      chimeAttendeeId: string,
      extUserId?: string
    ) => {
      return {
        name: participantName || "",
        attendeeId: chimeAttendeeId,
        externalUserId: extUserId || ""
      };
    };
  }, [meetingManager, participantName, attendeeId, externalUserId]);

  // Get attendee info and set name
  useEffect(() => {
    const getAttendeeInfo = async (
      chimeAttendeeId: string,
      externalUserId?: string
    ) => {
      if (meetingManager.getAttendee) {
        const attendeeInfo = await meetingManager.getAttendee(
          chimeAttendeeId,
          externalUserId
        );
        setAttendeeName(attendeeInfo.name);
        return attendeeInfo;
      }
    };

    if (!attendeeId || !externalUserId) return;
    getAttendeeInfo(attendeeId, externalUserId);
  }, [meetingManager, attendeeId, externalUserId]);

  return { attendeeName, attendeeId, externalUserId };
};
